export default {
    about_doctor: "Дәрігер туралы",
    account_manager: "Аккаунт менеджер",
    activated: "Іске қосылды",
    additional_info: "Қосымша ақпарат",
    administrator: "Әкімші",
    administrators: "Әкімшілер",
    amount_of_doctors: "Дәрігерлер саны",
    are_you_sure_you_want_to_delete_field: " Бағытты жойғыңыз келетініне сенімдісіз бе",
    assistants: "Ассистенттер",
    backup_code: "Сақтық көшірме коды",
    block: "Бұғаттау",
    block_noun: "Блок",
    browse_computer: "Файлдардан таңдау",
    by_cabinets: "Офис бойынша",
    by_days: "Күндер бойынша",
    by_days_of_week: "Апта күндері бойынша",
    by_even_days: "Жұп күндері бойынша",
    by_odd_days: "Тақ күндері бойынша",
    cabinet: "Кабинет",
    cabinets: "Шкафтар",
    chair: "Кресло",
    chairs: "Креслолар",
    clinic_access_request: "Сұрау клиникаға қолжетімді",
    config: "Конфигурация",
    confirm_password: "Құпия сөзді қайталау",
    curator: "Куратор",
    curators: "Кураторлар",
    dentist_plus_tech_support_requests_access_to_your_clinic: "Dentist+ техникалық қолдау сіздің клиникаңызға қатынауды сұрайды",
    doctor_position: "Дәрігердің лауазымы",
    doctor_specialty: "Дәрігерді мамандығы",
    enter_backup_code_note: "Екі факторлы аутентификацияны іске қосқан кезде алынған сақтық көшірме кодтарының бірін енгізіңіз. Әрбір сақтық көшірме кодын тек бір рет пайдалануға болатынын ескеріңіз",
    enter_code_from_authorization_app: "Телефоныңыздағы екі факторлы аутентификация қолданбасынан кодты енгізіңіз",
    field: "Бағыт",
    fields: "Бағыттар",
    functionality: "Функционал",
    login_and_password: "Логин және құпия сөз",
    manual_pay_system: "Қолмен төлем жүйесі",
    not_worked: "Пысықталмаған",
    partner: "Серіктес",
    password_does_not_match_confirmation: "Құпия сөз расталғанмен сәйкес келмейді",
    password_requirement_min_length: "Кемінде {min} таңба",
    password_requirement_mixed_case: "Латын бас және кіші әріптері",
    password_requirement_number: "Сан міндетті",
    password_requirement_symbol: "Арнайы таңба міндетті",
    percent: "Пайыз",
    period_from: "бастап кезең",
    period_to: "дейінгі кезең",
    phone2: "Телефон 2",
    profession: "Мамандық",
    rate: "Мөлшерлеме",
    rate_per_day: "Күніне мөлшерлеме",
    rate_per_hour: "Сағатына мөлшерлеме",
    rate_per_month: "Айына мөлшерлеме",
    reserve_codes: "Резервтік кодтар",
    roles: "Рөлдер",
    sale_good_percent: "Тауарларды сату пайызы",
    schedule_conflicts_found: "Ағымдағы жазбалармен кесте қайшылықтары табылды",
    seller: "Сатушы",
    staff: "Персонал",
    take_photo: "Фото жасау",
    technics: "Техниктер",
    turn_on: "Қосу",
    turned_off: "Өшірілген",
    two_factor_authorization: "Екі факторлы аутентификация",
    two_factor_authorization_setup_successfully: "Екі факторлы аутентификация сәтті іске қосылды",
    twofactor_setup_instructions: "<ul><li>App Store немесе Google Play дүкенінен аутентификация қолданбасын (мысалы, Google Authenticator, Microsoft Authenticator, Yandex.Key) жүктеп алыңыз.</li><li>Телефондағы қолданбадағы \"Код қосу\"/'+' түймесін түртіп, компьютер экранында көрсетілетін QR кодын сканерлеңіз.</li><li>Төмендегі қолданбаның 6 таңбалы кодын жасау үшін тиісті өріске сәйкес QR кодын енгізіңіз. байлаулар</li><li>Телефоныңызды жоғалтып алған жағдайда ұсынылған сақтық көшірме кодтарын (6 таңбалы кодты тексергеннен кейін пайда болады) қауіпсіз жерде сақтауды ұмытпаңыз</li></ul>",
    use_app_code: "Стандартты кодты пайдаланыңыз",
    use_backup_code: "Сақтық көшірме кодын пайдаланыңыз",
    user_data: "Пайдаланушының деректері",
    user_will_assigned_rights_selected_for_that_role: "Пайдаланушыға осы рөлге таңдалған құқықтар тағайындалады",
    weekend: "Демалыс",
    without_warehouse_form_note: "Қоймаға байланыссыз материалдар негізгі қоймадан немесе креслоға байланған қоймадан есептен шығарылады",
    work_day: "Жұмыс күні",
    work_days: "Жұмыс күндері",
    work_schedule: "Жұмыс кестесі",
    work_time: "Жұмыс уақыты",
    worked: "Пысықталды"
}
